import { api } from './api';

export const tenantsService = {
  getTenants: async () => (await api.get('/tenants/')).data,
  getTenantById: async (id) => (await api.get(`/tenants/${id}`)).data,
  createTenant: async (data) => (await api.post('/tenants/', data)).data,
  updateTenant: async (id, data) => (await api.put(`/tenants/${id}`, data)).data,
  deleteTenant: async (id) => { await api.delete(`/tenants/${id}`); },

  getSubTenants: async (tenantId) => (await api.get(`/tenants/${tenantId}/sub-tenants/`)).data,
  createSubTenant: async (tenantId, data) => (await api.post(`/tenants/${tenantId}/sub-tenants/`, data)).data,
  updateSubTenant: async (tenantId, subId, data) => (await api.put(`/tenants/${tenantId}/sub-tenants/${subId}`, data)).data,
  deleteSubTenant: async (tenantId, subId) => { await api.delete(`/tenants/${tenantId}/sub-tenants/${subId}`); },
};
